const leaguesSeasonsPropType = "./leagueSeasons";
const roundGamePropType = "./roundGame";
const footballRoundPropType = "./footballRound";

export {
	leaguesSeasonsPropType,
	roundGamePropType,
	footballRoundPropType,
};